import { type FormEvent, useState } from 'react';

import { displayName } from '../shared/branding';
import { Button } from '../shared/components/Button';
import { Input } from '../shared/components/Input';
import { useTranslation } from '../shared/i18n/useTranslation';

export function MfaPage() {
  const { t } = useTranslation();
  const [code, setCode] = useState<string>('');

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    // TODO M3.x: integrar com requestMFAReset / setMFAVerified callable.
  };

  return (
    <main className="mx-auto flex min-h-screen max-w-md flex-col justify-center gap-4 p-6">
      <p className="text-sm uppercase tracking-wide text-brand-700">
        {displayName('user-facing')}
      </p>
      <h1 className="text-3xl font-bold text-fg-DEFAULT">{t('auth.mfa.title')}</h1>
      <p className="text-fg-muted">{t('auth.mfa.placeholder')}</p>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <Input
          label={t('auth.mfa.code')}
          inputMode="numeric"
          autoComplete="one-time-code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
        <div className="flex gap-3">
          <Button type="submit" size="n2">
            {t('auth.mfa.submit')}
          </Button>
          <Button type="button" variant="ghost" size="n2">
            {t('auth.mfa.resend')}
          </Button>
        </div>
      </form>
    </main>
  );
}
